import React, { useState } from "react";
import {
  Layout,
  Avatar,
  Space,
  Dropdown,
  Menu,
  Typography,
  Switch,
  Button,
  Drawer,
} from "antd";
import {
  UserOutlined,
  LogoutOutlined,
  StarOutlined,
  StarFilled,
  MenuOutlined,
} from "@ant-design/icons";
import { connect } from "react-redux";
import { useInRouterContext, useNavigate } from "react-router-dom";
import { getUser } from "Util/index";
import { API_URL, CDN } from "Constants";
import MarkerSwitch from "components/marker/switch";
import NotificationBell from "components/Notifications/NotificationBell";
import useIsMobile from "Hooks/useIsMobile";
const { Header } = Layout;

// T2/100A132: logo guardado en el proyecto (regla: toda imagen local, nada de carga remota).
// Antes: `${CDN}/website/logo.png?t=${props.general.logo}` (servidor remoto REACT_APP_CDN).
// public/logo/jag.png es el logo JAG en blanco con fondo transparente, para la barra oscura.
// Usuario (2026-10-27): usar public/logo/logo_remove_bg.png. Antes:
// export const NAVBAR_LOGO_SRC = `${process.env.PUBLIC_URL || ""}/logo/jag.png`;
export const NAVBAR_LOGO_SRC = `${process.env.PUBLIC_URL || ""}/logo/logo_remove_bg.png`;
// Tamaño adaptable: alto fijo dentro de la barra (64 px) y ancho automático, con tope en celular
// para no empujar los botones. Fondo transparente (el PNG ya trae transparencia).
export const navbarLogoStyle = (isMobile) => ({
  height: isMobile ? 36 : 44,
  width: "auto",
  maxWidth: isMobile ? "45vw" : 200,
  objectFit: "contain",
  background: "transparent",
  display: "block",
});
const { Title } = Typography;

// T2/100A144: el logo lleva a la vista principal (inicio, "/"). Dentro del router navega sin
// recargar; fuera del router (p. ej. pruebas) es un enlace normal.
const HOME_PATH = "/";
const RouterLogoLink = ({ children }) => {
  const navigate = useNavigate();
  return (
    <a
      href={HOME_PATH}
      aria-label="Ir al inicio"
      style={{ display: "flex", alignItems: "center" }}
      onClick={(e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return; // abrir en otra pestaña
        e.preventDefault();
        navigate(HOME_PATH);
      }}
    >
      {children}
    </a>
  );
};
export const LogoLink = ({ children }) =>
  useInRouterContext() ? (
    <RouterLogoLink>{children}</RouterLogoLink>
  ) : (
    <a href={HOME_PATH} aria-label="Ir al inicio" style={{ display: "flex", alignItems: "center" }}>
      {children}
    </a>
  );

function Navbar(props) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useIsMobile();

  const cerrar = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  const { showSwitchMarker = true } = props;

  const User = getUser();

  const menu = [
    {
      key: 2,
      label: (
        <Button type="link" icon={<LogoutOutlined />} onClick={cerrar}>
          Salir
        </Button>
      ),
    },
  ];

  const userMenu = (
    <Dropdown menu={{ items: menu }} trigger={["click"]}>
      <Space size="small" align="end" style={{ marginLeft: isMobile ? 0 : 16 }}>
        <Avatar icon={<UserOutlined />} />
        <b style={{ color: isMobile ? undefined : "white" }}>{User?.name}</b>
      </Space>
    </Dropdown>
  );

  // NOTE: crossing the 768px breakpoint remounts NotificationBell/MarkerSwitch
  // (resets poll state) — known tradeoff of the two-branch render, not a bug.
  if (isMobile) {
    return (
      <Header style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        {/* T2/100A132: antes src={`${CDN}/website/logo.png?t=${props.general.logo}`} */}
        {/* Antes: style={{ width: 80 }} */}
        {/* T2/100A144: antes el logo no era clicable (solo <img>). */}
        <LogoLink>
          <img src={NAVBAR_LOGO_SRC} alt="JAG Ingeniería y Refrigeración" style={navbarLogoStyle(true)} />
        </LogoLink>
        <Space>
          {props.right}
          {showSwitchMarker && <MarkerSwitch />}
          <NotificationBell />
          <Button
            type="text"
            icon={<MenuOutlined style={{ color: "#fff", fontSize: 20 }} />}
            onClick={() => setDrawerOpen(true)}
            aria-label="Abrir menú"
          />
        </Space>
        <Drawer
          title={User?.name}
          placement="right"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        >
          <Space direction="vertical" style={{ width: "100%" }} size="middle">
            {props.children}
            {userMenu}
          </Space>
        </Drawer>
      </Header>
    );
  }

  return (
    <Header style={{ display: "flex" }}>
      <Space size="middle" align="center" style={{ marginRight: 16 }}>
        {/* T2/100A132: antes src={`${CDN}/website/logo.png?t=${props.general.logo}`} */}
        {/* Antes: style={{ width: 100 }} */}
        {/* T2/100A144: antes el logo no era clicable (solo <img>). */}
        <LogoLink>
          <img src={NAVBAR_LOGO_SRC} alt="JAG Ingeniería y Refrigeración" style={navbarLogoStyle(false)} />
        </LogoLink>
        <Title level={4} style={{ marginTop: 8 }}></Title>
      </Space>

      {props.children}

      <Space align="center" style={{ marginLeft: "auto" }}>
        {props.right}
        {showSwitchMarker && <MarkerSwitch />}
        <NotificationBell />
        {userMenu}
      </Space>
    </Header>
  );
}

const mapToState = (state) => {
  return { general: state.General };
};

export default connect(mapToState)(Navbar);
